import { injectable } from "inversify";
import databaseInstance from "../../index";

@injectable()
export class AdminMessagingService {
  private dbInstance: any = databaseInstance;

  private static instance: AdminMessagingService;

  constructor() {
    AdminMessagingService.instance = this;
  }

  public static getInstance() {
    if (!AdminMessagingService.instance) {
      AdminMessagingService.instance = new AdminMessagingService();
    }
    return AdminMessagingService.instance;
  }

  public initiateScheduledMessage: (
    groupId: number,
    scheduleData: any,
  ) => Promise<void> = (groupId, scheduleData) => {
    return new Promise<void>((resolve, reject) => {
      this.dbInstance
        .post(`/groups/${groupId}/scheduled-messages`, scheduleData)
        .then((response: any) => {
          resolve(response);
        })
        .catch((error: any) => {
          reject(error)
          new Error("Something went wrong!")
        });
    })
  }

  public updateScheduledMessage: (
    groupId: number,
    scheduleId: number,
    scheduleData: any,
  ) => Promise<void> = (groupId, scheduleId, scheduleData) => {
    return new Promise<void>((resolve, reject) => {
      this.dbInstance
        .put(`/groups/${groupId}/scheduled-messages/${scheduleId}`, scheduleData)
        .then((response: any) => {
          resolve(response);
        })
        .catch((error: any) => {
          reject(error)
          new Error("Something went wrong!")
        });
    })
  }

  public createMessageInSchedule: (
    groupId: number,
    scheduleId: number,
    messageData: any,
  ) => Promise<void> = (groupId, scheduleId, messageData) => {
    return new Promise<void>((resolve, reject) => {
      this.dbInstance
        .post(`/groups/${groupId}/scheduled-messages/${scheduleId}/messages`, messageData)
        .then((response: any) => {
          resolve(response);
        })
        .catch((error: any) => {
          reject(error)
          new Error("Something went wrong!")
        });
    });
  }

  public getScheduledMessages: (
    groupId: number,
    query: string,
    // page?: string
  ) => Promise<void> = (groupId, query) => {
    return new Promise<void>((resolve, reject) => {
      this.dbInstance
        .get(`/groups/${groupId}/scheduled-messages${query}`)
        .then((response: any) => {
          resolve(response);
        })
        .catch((error: any) => {
          reject(error)
          new Error("Something went wrong!")
        });
    })
  }

  public loadMore: (groupId: number, page: number) => Promise<void> = (groupId, page) => {
    return new Promise<void>((resolve, reject) => {
      this.dbInstance
        .get(`/groups/${groupId}/scheduled-messages/?page=${page}`)
        .then((response: any) => {
          resolve(response);
        })
        .catch((error: any) => {
          reject(error)
          new Error("Something went wrong!")
        });
    })
  }

  public deleteScheduledMessage: (
    groupId: number,
    scheduleId: number,
  ) => Promise<void> = (groupId, scheduleId) => {
    return new Promise<void>((resolve, reject) => {
      this.dbInstance
        .delete(`/groups/${groupId}/scheduled-messages/${scheduleId}`)
        .then(() => resolve())
        .catch((error: any) => {
          reject(error)
          new Error("Something went wrong!")
        });
    })
  }

  public getAudienceMembers: (
    groupId: number,
    audienceType: string,
    audienceIds: string,
  ) => Promise<void> = (groupId, audienceType, audienceIds) => {
    return new Promise<void>((resolve, reject) => {
      this.dbInstance
        .get(`/groups/${groupId}/scheduled-message-audience/members-count?audience_type=${audienceType}${audienceIds}`)
        .then((response: any) => resolve(response))
        .catch((error: any) => {
          reject(error)
          new Error("Something went wrong!")
        });
    });
  }

  public sendTestEmail: (
    groupId: number,
    scheduleId: number,
  ) => Promise<void> = (groupId, scheduleId) => {
    return new Promise<void>((resolve, reject) => {
      this.dbInstance
        .post(`/groups/${groupId}/scheduled-messages/${scheduleId}/test`)
        .then(() => resolve())
        .catch((error: any) => {
          reject(error)
          new Error("Something went wrong!")
        });
    });
  }

  public createWorkflow: (groupId: number, payload: any) => Promise<void> = (groupId, payload) => {
    return new Promise<void>((resolve, reject) => {
      this.dbInstance
        .post(`/groups/${groupId}/workflows`, payload)
        .then((response: any) => resolve(response))
        .catch((error: any) => {
          reject(error)
          new Error("Something went wrong!")
        });
    });
  }

  public editWorkflow: (groupId: number, workflowId: number, payload: any) => Promise<void> = (groupId, workflowId, payload) => {
    return new Promise<void>((resolve, reject) => {
      this.dbInstance
        .put(`/groups/${groupId}/workflows/${workflowId}`, payload)
        .then((response: any) => resolve(response))
        .catch((error: any) => {
          reject(error)
          new Error("Something went wrong!")
        });
    });
  }

  public fetchAworflow: (groupId: number, workflowId: number) => Promise<void> = (groupId, workflowId) => {
    return new Promise<void>((resolve, reject) => {
      this.dbInstance
        .get(`/groups/${groupId}/workflows/${workflowId}`)
        .then((response: any) => resolve(response))
        .catch((error: any) => {
          reject(error)
          new Error("Something went wrong!")
        });
    });
  }

  public deleteAworflow: (groupId: number, workflowId: number) => Promise<void> = (groupId, workflowId) => {
    return new Promise<void>((resolve, reject) => {
      this.dbInstance
        .delete(`/groups/${groupId}/workflows/${workflowId}`)
        .then((response: any) => resolve(response))
        .catch((error: any) => {
          reject(error)
          new Error("Something went wrong!")
        });
    });
  }

  public duplicateworflow: (groupId: number, workflowId: number) => Promise<void> = (groupId, workflowId) => {
    return new Promise<void>((resolve, reject) => {
      this.dbInstance
        .post(`/groups/${groupId}/workflows/${workflowId}/duplicate`)
        .then((response: any) => resolve(response))
        .catch((error: any) => {
          reject(error)
          new Error("Something went wrong!")
        });
    });
  }

  public fetchWorkflowEvents: (groupId: number) => Promise<void> = (groupId) => {
    return new Promise<void>((resolve, reject) => {
      this.dbInstance
        .get(`/groups/${groupId}/workflow-events`)
        .then((response: any) => resolve(response))
        .catch((error: any) => {
          reject(error)
          new Error("Something went wrong!")
        });
    });
  }

  public fetchEventsActions: (groupId: number) => Promise<void> = (groupId) => {
    return new Promise<void>((resolve, reject) => {
      this.dbInstance
        .get(`/groups/${groupId}/workflow-actions`)
        .then((response: any) => resolve(response))
        .catch((error: any) => {
          reject(error)
          new Error("Something went wrong!")
        });
    });
  }

  public fetchWorkflowsList: (groupId: number, query?: string) => Promise<void> = (groupId, query = '') => {
    return new Promise<void>((resolve, reject) => {
      this.dbInstance
        .get(`/groups/${groupId}/workflows${query}`)
        .then((response: any) => resolve(response))
        .catch((error: any) => {
          reject(error)
          new Error("Something went wrong!")
        });
    });
  }

  public fetchWorkflowsExecutionsList: (groupId: number, query?: string) => Promise<void> = (groupId, query = '') => {
    return new Promise<void>((resolve, reject) => {
      this.dbInstance
        .get(`/groups/${groupId}/workflow-executions${query}`)
        .then((response: any) => resolve(response))
        .catch((error: any) => {
          reject(error)
          new Error("Something went wrong!")
        });
    });
  }

  public loadMoreWorkflowsList: (groupId: number, page: number, query?: string) => Promise<void> = (groupId, page, query = '') => {
    return new Promise<void>((resolve, reject) => {
      this.dbInstance
        .get(`/groups/${groupId}/workflows?page=${page}&search=${query}`)
        .then((response: any) => {
          resolve(response);
        })
        .catch((error: any) => {
          reject(error)
          new Error("Something went wrong!")
        });
    })
  }

  public loadMoreWorkflowsListExecutions: (groupId: number, page: number, query?: string) => Promise<void> = (groupId, page, query = '') => {
    return new Promise<void>((resolve, reject) => {
      this.dbInstance
        .get(`/groups/${groupId}/workflow-executions?page=${page}&search=${query}`)
        .then((response: any) => {
          resolve(response);
        })
        .catch((error: any) => {
          reject(error)
          new Error("Something went wrong!")
        });
    })
  }

  public fetchEventsResource: (
    groupId: number,
    resourceId: number,
    payload: any

  ) => Promise<void> = (groupId, resourceId, payload) => {
    return new Promise<void>((resolve, reject) => {
      this.dbInstance
        .post(`/groups/${groupId}/third-party-applications/${resourceId}/resource-search`,
          payload
        )
        .then((response: any) => resolve(response))
        .catch((error: any) => {
          reject(error)
          new Error("Something went wrong!")
        });
    });
  }

  public activateWorkflows: (groupId: number, workflowID: number) => Promise<void> = (groupId, workflowID) => {
    return new Promise<void>((resolve, reject) => {
      this.dbInstance
        .post(`/groups/${groupId}/workflows/${workflowID}/activations`)
        .then((response: any) => resolve(response))
        .catch((error: any) => {
          reject(error)
          new Error("Something went wrong!")
        });
    });
  }

  public deactivateWorkflows: (groupId: number, workflowID: number) => Promise<void> = (groupId, workflowID) => {
    return new Promise<void>((resolve, reject) => {
      this.dbInstance
        .delete(`/groups/${groupId}/workflows/${workflowID}/activations`)
        .then((response: any) => resolve(response))
        .catch((error: any) => {
          reject(error)
          new Error("Something went wrong!")
        });
    });
  }

  public cancelWorkflowExecution: (groupId: number, workflowID: number) => Promise<void> = (groupId, workflowID) => {
    return new Promise<void>((resolve, reject) => {
      this.dbInstance
        .post(`/groups/${groupId}/workflow-executions/${workflowID}/cancel`)
        .then((response: any) => resolve(response))
        .catch((error: any) => {
          reject(error)
          new Error("Something went wrong!")
        });
    });
  }

  public rerunworkflowExecution: (groupId: number, workflowID: number, taskId: number) => Promise<void> = (groupId, workflowID, taskId) => {
    return new Promise<void>((resolve, reject) => {
      this.dbInstance
        .post(`/groups/${groupId}/workflow-executions/${workflowID}/tasks/${taskId}/run`)
        .then((response: any) => resolve(response))
        .catch((error: any) => {
          reject(error)
          new Error("Something went wrong!")
        });
    });
  }

  public previewWorkflowEmailTask: (groupId: number, payload: any) => Promise<void> = (groupId, payload) => {
    return new Promise<void>((resolve, reject) => {
      this.dbInstance
        .post(`/groups/${groupId}/workflows/preview-email`, payload)
        .then((response: any) => resolve(response))
        .catch((error: any) => {
          reject(error)
          new Error("Something went wrong!")
        });
    });
  }

  public fetchActiveUserInWorkflow: (groupId: number, workflowId: number) => Promise<void> = (groupId, workflowId) => {
    return new Promise<void>((resolve, reject) => {
      this.dbInstance
        .get(`/groups/${groupId}/workflows/${workflowId}/active-executions`)
        .then((response: any) => {
          resolve(response);
        })
        .catch((error: any) => {
          reject(error)
          new Error("Something went wrong!")
        });
    })
  }

  public fetchWorkflowTemplates: () => Promise<void> = () => {
    return new Promise<void>((resolve, reject) => {
      this.dbInstance
        .get(`/workflow-templates`)
        .then((response: any) => {
          resolve(response);
        })
        .catch((error: any) => {
          reject(error)
          new Error("Something went wrong!")
        });
    })
  }

  public fetchWorkflowFilterFields: (groupId: number, eventID: number, searchString: string) => Promise<void> = (groupId, eventID, searchString = '') => {
    return new Promise<void>((resolve, reject) => {
      this.dbInstance
        .get(`/groups/${groupId}/workflow-filter-fields?workflow_event=${eventID}&search=${searchString}`)
        .then((response: any) => {
          resolve(response);
        })
        .catch((error: any) => {
          reject(error)
          new Error("Something went wrong!")
        });
    })
  }

  public fetchWorkflowFilterConditions: (groupId: number, searchString: string) => Promise<void> = (groupId, searchString = '') => {
    return new Promise<void>((resolve, reject) => {
      this.dbInstance
        .get(`/groups/${groupId}/workflow-filter-conditions?search=${searchString}`)
        .then((response: any) => {
          resolve(response);
        })
        .catch((error: any) => {
          reject(error)
          new Error("Something went wrong!")
        });
    })
  }

  public loadMoreWorkflowTemplates: (page: number) => Promise<void> = (page) => {
    return new Promise<void>((resolve, reject) => {
      this.dbInstance
        .get(`/workflow-templates?page=${page}`)
        .then((response: any) => {
          resolve(response);
        })
        .catch((error: any) => {
          reject(error)
          new Error("Something went wrong!")
        });
    })
  }

  public testWebhookURL: (groupId: number, workflowId: number, payload: {}) => Promise<void> = (groupId, workflowId, payload) => {
    return new Promise<void>((resolve, reject) => {
      this.dbInstance
        .post(`/groups/${groupId}/workflows/${workflowId}/test-workflow-webhook`, payload)
        .then((response: any) => resolve(response))
        .catch((error: any) => {
          reject(error)
          new Error("Something went wrong!")
        });
    });
  }

  public testWebhookURLResults: (groupId: number, workflowId: number, payload: {}) => Promise<void> = (groupId, workflowId, payload) => {
    return new Promise<void>((resolve, reject) => {
      this.dbInstance
        .post(`/groups/${groupId}/workflows/${workflowId}/test-workflow-webhook-results`, payload)
        .then((response: any) => resolve(response))
        .catch((error: any) => {
          reject(error)
          new Error("Something went wrong!")
        });
    });
  }

  public duplicateScheduledMessage: (groupId: number, scheduleId: number) => Promise<void> = (groupId, scheduleId) => {
    return new Promise<void>((resolve, reject) => {
      this.dbInstance
        .post(`/groups/${groupId}/scheduled-messages/${scheduleId}/duplicate`)
        .then((response: any) => resolve(response))
        .catch((error: any) => {
          reject(error)
          new Error("Something went wrong!")
        });
    });
  }

  public updatePostAuthor: (groupId: number, postId: number, userId: number) => Promise<void> = (groupId, postId, userId) => {
    return new Promise<void>((resolve, reject) => {
      this.dbInstance
        .put(`/groups/${groupId}/posts/${postId}/update-author`, {
          user_id: userId
        })
        .then((response: any) => resolve(response.data))
        .catch((error: any) => {
          reject(error)
          new Error("Something went wrong!")
        });
    });
  }

  public fetchLeadableFields: (
    groupId: number,
    pageId: number,
    leadableId: any
  ) => Promise<void> = (groupId, pageId, leadableId) => {
    return new Promise<void>((resolve, reject) => {
      this.dbInstance
        .get(`/groups/${groupId}/pages/${pageId}/leadables/${leadableId}/fields`)
        .then((response: any) => resolve(response))
        .catch((error: any) => {
          reject(error)
          new Error("Something went wrong!")
        });
    });
  }

  public fetchCoursesFormFields: (
    groupId: number,
    courseContentsId: number
  ) => Promise<void> = (groupId, courseContentsId) => {
    return new Promise<void>((resolve, reject) => {
      this.dbInstance
        .get(`/groups/${groupId}/course-contents/${courseContentsId}/fields`)
        .then((response: any) => resolve(response))
        .catch((error: any) => {
          reject(error)
          new Error("Something went wrong!")
        });
    });
  }

}
